import { Link } from 'react-router-dom'
import Logo from '../components/Logo'

export default function Terms() {
  return (
    <div className="min-h-[100dvh] px-6 py-12" style={{ background: 'var(--fp-bg)', color: 'var(--fp-text)' }}>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <Logo size="md" />
        </div>

        <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'var(--fp-font-heading)' }}>Terms of Service</h1>
        <p className="text-sm mb-8" style={{ color: 'var(--fp-text-muted)' }}>Last updated: 6 April 2026</p>

        <div className="space-y-6 text-sm leading-relaxed" style={{ color: 'var(--fp-text-muted)' }}>
          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>1. Acceptance of Terms</h2>
            <p>
              By accessing and using FlickPick ("the Service"), you agree to be bound by these
              Terms of Service. If you do not agree to these terms, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>2. Description of Service</h2>
            <p>
              FlickPick is a free web application that helps groups of people (families, friends,
              housemates) decide what movie to watch together. The Service allows users to create
              groups, build shared watchlists, spin a wheel to pick a movie, and rate movies after
              watching them.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>3. User Accounts</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>You may create an account using email/password, Google, or Facebook login.</li>
              <li>You are responsible for maintaining the security of your account.</li>
              <li>You must provide accurate information when creating your account.</li>
              <li>You may not create accounts for the purpose of abusing the Service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>4. Acceptable Use</h2>
            <p className="mb-2">You agree not to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Use the Service for any unlawful purpose.</li>
              <li>Attempt to gain unauthorised access to any part of the Service.</li>
              <li>Interfere with or disrupt the Service or its infrastructure.</li>
              <li>Scrape, crawl, or use automated means to access the Service without permission.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>5. Content and Data</h2>
            <p>
              Movie information displayed in FlickPick is sourced from third-party services
              including TMDB (The Movie Database) and DoesTheDogDie.com. We do not guarantee
              the accuracy, completeness, or timeliness of this information. Content warnings
              are provided as a guide only and should not be relied upon as the sole source of
              information about a film's content.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>6. Intellectual Property</h2>
            <p>
              The FlickPick name, logo, and original code are the property of their respective
              owners. Movie posters, metadata, and images are the property of their respective
              rights holders and are used under the terms of the TMDB API.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>7. Disclaimer of Warranties</h2>
            <p>
              The Service is provided "as is" and "as available" without warranties of any kind,
              either express or implied. We do not warrant that the Service will be uninterrupted,
              secure, or error-free.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, FlickPick and its operators shall not be
              liable for any indirect, incidental, special, consequential, or punitive damages
              arising out of or relating to your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>9. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your access to the Service at any
              time, for any reason, without notice. You may also delete your account at any
              time by contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>10. Changes to Terms</h2>
            <p>
              We may update these Terms of Service from time to time. Continued use of the
              Service after changes constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>11. Governing Law</h2>
            <p>
              These Terms are governed by the laws of New South Wales, Australia.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>12. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us
              at <a href="mailto:hello@findability.com.au" className="underline" style={{ color: 'var(--fp-red)' }}>hello@findability.com.au</a>.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link to="/login" className="text-sm underline" style={{ color: 'var(--fp-text-muted)' }}>
            &larr; Back to FlickPick
          </Link>
        </div>
      </div>
    </div>
  )
}
